import {Component, OnInit} from '@angular/core';
import {ExcTranslation} from 'exc-core';
import {ExcListConfig, OverlayConfig, OverlayRef} from 'exc-controls';
import {ExcRestService} from 'exc-rest';
import {ExcFilter, ExcFilterCondition, FilterSortService} from '../../filter-sort-service.service';

@Component({
  selector: 'app-modal-dealer-successor',
  templateUrl: './modal-dealer-successor.component.html',
  styles: []
})
export class ModalDealerSuccessorComponent extends ExcTranslation implements OnInit {

  dealerList = {
    selected: undefined as any,
    isLoading: false,
    data: [] as any[],
    paging: {} as any,
    searchValue: '',
    showResults: false,
    select(dealer: any) {
      this.selected = dealer;
      console.log(this.selected);
    },
    hideResult: (): void => {
      setTimeout(() => {
        this.dealerList.showResults = false;
      }, 175);
    },
  };

  dealerListConfig: ExcListConfig = new ExcListConfig();
  filterData = [] as any[];
  sortData = [] as any[];

  DealerID;
  Comment = '';

  constructor(
    private overlayRef: OverlayRef
    , private overlayConfig: OverlayConfig
    , private excRest: ExcRestService
    , private excFss: FilterSortService
  ) {
    super();
  }

  ngOnInit() {
    this.DealerID = this.overlayConfig.data.DealerID;

    this.filterData =  [
      new ExcFilter(1, this.getRessource('Dealer'), 'DealerInactive', new ExcFilterCondition('=', false), 'DealerActive', this.getRessource('Active'), true)
    ];
  }

  loadDealerList (searchValue: string) {
    const _self = this;
    _self.dealerList.searchValue = searchValue;

    if (searchValue) {
      let mi = _self.dealerListConfig.GetMetaInfo();
      mi =  this.excFss.ApplyFilter(mi, this.filterData, this.sortData);
      mi.dataSort = {};

      const url = _self.excRest.computeUrl('DealerR_List', {fts: searchValue});
      _self.dealerList.isLoading = true;
      _self.excRest.get(url, {MetaInfo: mi}).subscribe(ret => {
        if (ret) {
          _self.dealerList.data = ret.data.Dealer1;
          _self.dealerList.data = _self.dealerList.data
            .filter(dealer => dealer.DealerID !== this.DealerID);
          _self.dealerList.paging = ret.paging.Dealer1;
          _self.dealerList.isLoading = false;
          _self.dealerList.showResults = true;
        }
      });
    } else {
      _self.dealerList.showResults = true;
    }
  }


  resetSearch(): void {
    setTimeout(() => {
      this.dealerList.data = [];
      this.dealerList.searchValue = '';
      this.dealerList.showResults = true;
    }, 150);
  }
}
